/** «ahora», «hace 5 min», «hace 2 h», «ayer» o la fecha corta, como en la campana del diseño. */
export function haceCuanto(fecha: string | undefined, ahora: Date = new Date()): string {
    if (fecha === undefined) {
        return '';
    }
    const momento = new Date(fecha);
    const minutos = Math.floor((ahora.getTime() - momento.getTime()) / 60_000);
    if (Number.isNaN(minutos)) {
        return '';
    }
    if (minutos < 1) {
        return 'ahora';
    }
    if (minutos < 60) {
        return `hace ${String(minutos)} min`;
    }
    const horas = Math.floor(minutos / 60);
    if (horas < 24) {
        return `hace ${String(horas)} h`;
    }
    if (horas < 48) {
        return 'ayer';
    }
    return momento.toLocaleDateString('es-ES', { day: 'numeric', month: 'short' });
}

